import {Link} from 'react-router';
import * as Bootstrap from 'react-bootstrap';
import * as React from 'react';
import {connect} from 'react-redux';
import * as Locale from '../model/locale';
import {hasComponentAccess} from "../model/account";
import {ACCOUNT_ROUTE_ADMIN, ACCOUNT_ROUTE_SETTINGS, ACCOUNT_ROUTE_USER_MANAGEMENT} from '../model/routes/main';
import {logoutUser} from '../model/account';

import {AppRoute, navigationAppRoutes} from '../model/routes/main';
import {PrivilegedSiteComponent} from "../model/base";


@connect(
    state => ({textForKey: state.data.textForKey})
)
export class UserNavigation extends React.Component<any, any> {

    render() {
        let {user, dispatch, textForKey} = this.props;
        let {username, company} = user;

        let onLogout = function() {
            dispatch(logoutUser());
        };
        let adminLink = null;
        let userManagementLink = null;
        let settingsClass = 'settings-link';
        if (hasComponentAccess(user, PrivilegedSiteComponent.Admin)) {
            adminLink = (
                <li>
                    <a className={settingsClass} href={ACCOUNT_ROUTE_ADMIN}>
                        {textForKey(Locale.TEXT_MENU_ADMIN)}
                    </a>
                </li>
            );
        }

        if (hasComponentAccess(user, PrivilegedSiteComponent.UserManagement)) {
            userManagementLink = (
                <li>
                    <a className={settingsClass} href={this.getUserManagementUrl(user.realm)}>
                        {textForKey(Locale.TEXT_MENU_KEYCLOAK)}
                    </a>
                </li>
            );
        }


        let preventDefault = e => e.preventDefault();

        return (
            <Bootstrap.Dropdown id="dropdown-user">
                <a href="#"
                   bsRole="toggle"
                   onClick={preventDefault}
                   className="dropdown-user dropdown-toggle">
                    {username} | {company.name}
                </a>
                <ul bsRole="menu" className="dropdown-menu">
                    <li>
                        <a className={settingsClass}
                           href={ACCOUNT_ROUTE_SETTINGS}>
                            {textForKey(Locale.TEXT_MENU_SETTINGS)}
                        </a>
                    </li>
                    {userManagementLink}
                    {adminLink}
                    <li>
                        <a className={`${settingsClass} logout-link`}
                           href="#"
                           onClick={onLogout}>
                            {textForKey(Locale.TEXT_MENU_LOGOUT)}
                        </a>
                    </li>
                </ul>
            </Bootstrap.Dropdown>
        );
    }

    private getUserManagementUrl(realm) {
        return ACCOUNT_ROUTE_USER_MANAGEMENT + realm + '/console/';
    }

}

@connect(
    state => ({user: state.data.user,
               unclearedAlarmCount: state.data.summary.alarms.uncleared_count,
               textForKey: state.data.textForKey})
)
export class Navbar extends React.Component<any, any> {

    public static contextTypes: React.ValidationMap<any> = {
        history: React.PropTypes.object.isRequired
    };

    public context: { history: ReactRouter.History };

    render() {
        let {user} = this.props;
        let userNavigation = null;
        // TODO: add support for login/signup links when required
        if (user.username) {
            userNavigation = (
              <Bootstrap.Nav pullRight>
                <UserNavigation user={user}/>
              </Bootstrap.Nav>
            );
        }

        return (
          <Bootstrap.Navbar>
            <Bootstrap.Navbar.Header>
              <Bootstrap.Navbar.Toggle />
            </Bootstrap.Navbar.Header>
            <Bootstrap.Navbar.Collapse>
              <Bootstrap.Nav>

                {this.buildLinks()}

              </Bootstrap.Nav>

              {userNavigation}

            </Bootstrap.Navbar.Collapse>
            </Bootstrap.Navbar>
        );
    }

    private buildLinks() {
        let context = this.context;
        let props = this.props;
        const routes = navigationAppRoutes.filter(r => r.visibleForUser(this.props.user));
        return routes.map(function(appRoute: AppRoute) {
            let label, text = props.textForKey(appRoute.label), liParams: any = { key: appRoute.name };

            if (appRoute.name === 'alarms' && props.unclearedAlarmCount) {
                label = <span className="alarm-count">{props.unclearedAlarmCount}</span>;
            }
            // must differentiate between external links and router
            // links manually
            // https://github.com/rackt/react-router/issues/1147
            // todo: will likely need similar logic elsewhere. perhaps extend
            // react-router Link component with this logic?
            let link;
            if (appRoute.external) {
                let linkParams = {
                    className: `link-${appRoute.name} navbar-link`,
                    href: appRoute.path
                };
                link = <a {...linkParams}>{text}{label}</a>;
            } else {
                if (context.history.isActive(appRoute.name)) {
                    liParams.className = 'active';
                }
                let linkParams = {
                    activeClassName: 'active',
                    className: `link-${appRoute.name} navbar-link`,
                    to: appRoute.name
                };
                link = <Link {...linkParams}>{text}{label}</Link>;
            }
            return (
                <li {...liParams}>{link}</li>
            );
        });
    }
}
